import generate from '@babel/generator';
import { parse } from '@babel/parser';
import traverse from '@babel/traverse';
import prettier from 'prettier';

import { visitor } from './visitor';

const plugins = [
  'jsx',
  'flow',
  'flowComments',
  'objectRestSpread',
  'classProperties',
  'asyncGenerators',
  'dynamicImport',
  'numericSeparator',
  'throwExpressions',
];

const FLOW_COMMENT = '/* @flow */';

export const convert = (code: string): string => {
  const ast = parse(code, { plugins, sourceType: 'module' });

  traverse(ast, visitor);

  let { code: outputCode } = generate(ast, { retainLines: true, compact: false }, code);

  if (outputCode.startsWith(FLOW_COMMENT)) {
    outputCode = outputCode.slice(FLOW_COMMENT.length);
  }

  return prettier.format(outputCode, {
    arrowParens: 'always',
    parser: 'typescript',
    printWidth: 120,
    singleQuote: true,
    trailingComma: 'all',
  });
};
